export default __webpack_public_path__ + "static/media/tl3.96486696.png";